export default __webpack_public_path__ + "static/media/card-proveedores.379a60f3.png";